import React  from "react";
import { withStyles } from '@material-ui/core/styles';
import { injectIntl } from "react-intl";
import FormLabel from '@material-ui/core/FormLabel';
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import TextField from '@material-ui/core/TextField';
import Checkbox from '@material-ui/core/Checkbox';
import {MenuItem} from "@material-ui/core";
 import { Link,Redirect } from "react-router-dom";
import { EditorState,convertToRaw,ContentState } from 'draft-js';
 import { Editor } from 'react-draft-wysiwyg';
 import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';

import './react-draft-wysiwyg.css';


import Annotation from 'react-image-annotation'

import clsx from 'clsx';
 import { createTemplateData
//  ,getRolesByAccount 
} from "../../crud/auth.crud";
import { Figure } from "react-bootstrap";
import { IconButton,Tooltip } from '@material-ui/core';
import {  format } from 'date-fns';
import PrintIcon from '@material-ui/icons/Print';

const useStyles = withStyles(theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  dense: {
    marginTop: theme.spacing(2),
  },
  menu: {
    width: 200,
  },
}));


const styles = {
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    //marginLeft: theme.spacing(1),
    //marginRight: theme.spacing(1),
  },
  dense: {
    //marginTop: theme.spacing(2),
  },
  menu: {
    width: 200,
  },
   formControl: {
    //margin: theme.spacing(3),
  },
};


class AddTemplateData extends React.Component {

state = {
	editorState: EditorState.createEmpty(),
    	patient:{},
    	template:{},
    	menu: false,
    	annotations: [],
    annotation: {},
    type:'RECTANGLE',
    redirect:false,
  	}
	
constructor(props)
{
  super(props);
  let editorState = EditorState.createEmpty();
  let template={fieldGroups:[{fields:[{}]}]};
  let contentBlock = null;
  console.log("patient id"+this.props.location);
  if(this.props.location!==undefined && this.props.location!==null && this.props.location.data!==undefined&&  this.props.location.data !== null)
  {
  	console.log("props:::",this.props.location.data);
  	this.props.location.data.template.fieldGroups.map((fg)=>(
  			fg.fields.filter(x=> x.dataType === "wysiwyg").map((f)=>{

  				let contentHTML = f.imagePosition;
  				contentHTML = contentHTML.replaceAll("$$CURRENTDATE$$",format(new Date(),"MM/dd/yyyy"));
  				contentHTML = contentHTML.replaceAll("$$P.FIRSTNAME$$",this.props.location.data.patient.firstName);
  				contentHTML = contentHTML.replaceAll("$$P.LASTNAME$$",this.props.location.data.patient.lastName);
  				contentHTML = contentHTML.replaceAll("$$P.GENDER$$",this.props.location.data.patient.gender ==="male" ? "He" : "She");

  				contentBlock = htmlToDraft(contentHTML);
			    if (contentBlock) {
			      const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
			       editorState = EditorState.createWithContent(contentState);
			     
			    }
			  }
  			)
  	))
  	this.state = {
      editorState: editorState,
      template:this.props.location.data.template,
      patient: this.props.location.data.patient,
      fromPath: this.props.location.data.fromPath,
       status:false,
      statusMessage:'',
      alertType:'alert-success',
      loading:false,
      statusColor:'alert-success',
      annotations: [],
    	annotation: {},
    	type:'RECTANGLE',
    	redirect:false,
      
    };
  }
  else if(props.data!==null && props.data!==undefined)
  {
	//console.log("props:::",this.props.location.data);
	props.data.template.fieldGroups.map((fg)=>(
			fg.fields.filter(x=> x.dataType === "wysiwyg").map((f)=>{

				let contentHTML = f.imagePosition;
				contentHTML = contentHTML.replaceAll("$$CURRENTDATE$$",format(new Date(),"MM/dd/yyyy"));
				contentHTML = contentHTML.replaceAll("$$P.FIRSTNAME$$",props.data.patient.firstName);
				contentHTML = contentHTML.replaceAll("$$P.LASTNAME$$",props.data.patient.lastName);
				contentHTML = contentHTML.replaceAll("$$P.GENDER$$",props.data.patient.gender ==="male" ? "He" : "She");

				contentBlock = htmlToDraft(contentHTML);
			  if (contentBlock) {
				const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
				 editorState = EditorState.createWithContent(contentState);
			   
			  }
			}
			)
	))
	this.state = {
	editorState: editorState,
	template:props.data.template,
	patient: props.data.patient,
	fromPath: props.data.fromPath,
	 status:false,
	statusMessage:'',
	alertType:'alert-success',
	loading:false,
	statusColor:'alert-success',
	annotations: [],
	  annotation: {},
	  type:'RECTANGLE',
	  redirect:false,
	
  };
  }
  else
  {
  		this.state = {
      editorState: EditorState.createEmpty(),
      template:{},
      patient:{},
       status:false,
      statusMessage:'',
      alertType:'alert-success',
      loading:false,
      statusColor:'alert-success',
      redirect:false,
      
    };
  }
 
  
}

onEditorStateChange: Function = (editorState) => {
    this.setState({
      editorState,
    });
  };

onChange = (annotation) => {
    this.setState({ annotation })
  }

  onSubmit = (annotation) => {
    const { geometry, data } = annotation

    this.setState({
      annotation: {},
      annotations: this.state.annotations.concat({
        geometry,
        data: {
          ...data,
          id: Math.random()
        }
      })
    })
  }

   renderRedirect = () => {
    if (this.state.redirect && this.state.fromPath!=='/createpatient') {
      return <Redirect to={{pathname:this.state.fromPath, data:this.state.patient}} />
    }
  }


submitForm = event => {
	const {template,patient, ...inputFields } = this.state;
	console.log(inputFields);
	//console.log(template);
	let postData = {};
	this.state.template.fieldGroups.map((groups) => {
		groups.fields.map((field) => {
			//const node = ReactDOM.findDOMNode(this.refs[field.fieldName]);
			//console.log(field.fieldName+"--"+node);
			if(field.dataType === "wysiwyg")
			{
				postData[field.fieldName] = draftToHtml(convertToRaw(this.state.editorState.getCurrentContent()));
			}
			else
			{
				postData[field.fieldName] = inputFields[field.fieldName];
			}

		})
    
    // do what you want to do with `node`
  })
		//console.log("to html:::",draftToHtml(convertToRaw(this.state.editorState.getCurrentContent())));
    let formdata = {};
    formdata.formData = postData;
    formdata.templateKey = this.state.template.templateId;
    formdata.templateId = this.state.template.templateId;
    formdata.templateName = this.state.template.templateName;
    formdata.pEntityId = this.state.patient.pEntityId;
    formdata.pId = this.state.patient.id;
    //formdata.annotations = this.state.annotations;
    //formdata.pEntityKey = 
    console.log("postdata formated::::",postData);

    this.setState({loading:false});
	createTemplateData(patient.id,formdata)
                      .then(resp => {
                        //props.register(accessToken);
                       
                       this.setState({status:true,
                       statusMessage:'New Report has been created successfully',
                        alertType:'alert-success',loading:false,redirect:true});
                         window.scrollTo(0,0);
                       
                       
                      })
                      .catch(() => {
                        this.setState({loading:false});
                      });
                      

	event.preventDefault();
}

handleChange = event => {
	this.setState({
		[event.currentTarget.name] : event.currentTarget.value
	})
}

handleCheckBoxChange = event => {

	console.log(event.currentTarget.name + "---"+ event.currentTarget.value);
	//console.log(event);
	let chk = this.state[event.currentTarget.name];
	let chkvalue=[];
	if(chk!=null)
	{
		chk.push(event.currentTarget.value);
	}
	else
	{
		chk = [event.currentTarget.value];
	}
	this.setState({
		[event.currentTarget.name] : chk
	})
}

	render()
	{
		const patient = this.state.patient;
    	return (
    		<>
    			{this.renderRedirect()}
    			 {this.state.status && (
                        <div role="alert" className={"alert "+this.state.statusColor}>
                          <div className="alert-text">{this.state.statusMessage}</div>
                        </div>
                      )}

    			<div className="row">
        			<div className="col-xl-12">
        				<div className="kt-portlet kt-portlet--height-fluid">
                			<div className="kt-portlet__body">
                				<div className="row">
                					<div className="col">
                				 		<h5>Name: {patient.firstName + ' ' + patient.lastName}</h5>
                				 	</div>
                				 	<div className="col">
                				 		<h5>DOB: {format(new Date(patient.dateOfBirth), 'MM/dd/yyyy')}</h5>
                				 	</div>
                				 	<div className="col">
                				 		<h5>Mobile: {patient.mobile}</h5>
                				 	</div>
                				 	
                				</div>
		        				<div className="row">
		        						{this.state.template.templateLogoPath!=null &&
								        <div className="col-lg-6">
								                 <Figure style={{'text-align':'left'}}>
									              <Figure.Image
									                
									                alt="171x180"
									                src={this.state.template.templateLogoPath}
									              />
								              
								            	</Figure>
								        </div>
								    	}
								    	{this.state.template.templateImagePath!=null &&
								        <div className="col-lg-6">
								                 {/*<Figure style={{'text-align':'right'}}>
									              <Figure.Image
									                
									                alt="171x180"
									                src={this.state.template.templateImagePath}
									              />
								              
								            	</Figure>*/}
								            	<TextField  style={{'width':'100%'}} name="annotationType"
						                            id="annotationType" onChange={(e)=> this.setState({type:e.target.value})} label="Choose Shape"  select>
						                            <MenuItem key="RECTANGLE" value="RECTANGLE">Rectangle</MenuItem>
						                            <MenuItem key="OVAL" value="OVAL">Oval</MenuItem>
						                            
						                        </TextField>
								            	<Annotation
										          src={this.state.template.templateImagePath}
										          alt='Two pebbles anthropomorphized holding hands'

										          annotations={this.state.annotations}

										          type={this.state.type}
										          value={this.state.annotation}
										          onChange={this.onChange}
										          onSubmit={this.onSubmit}
										        />
								
							        	</div>
							        	}
							       </div>
							       </div>
							       </div>
							   </div>
			      </div>

    			<form onSubmit={this.submitForm}>
    			{this.state.template.fieldGroups != null && this.state.template.fieldGroups.map((fieldGroup,index)=>(

	    			<div className="row">
	    				<div className="col-lg-12">
	    					<div className="kt-portlet">
		    					<div className="kt-portlet__head">
									<div className="kt-portlet__head-label">
										<h3 className="kt-portlet__head-title">
											{fieldGroup.groupName}
										</h3>
									</div>
								</div>
			    				<div className="kt-portlet__body">
					        		
					        				<div className="row">
					        					<div className="col">
					        						{fieldGroup.fields !== null && fieldGroup.fields.map((field)=>(
					        							<>
					        											{field.dataType === "textbox" &&
					        							
						        										<TextField
									                          margin="normal"
									                          label={field.displayName}
									                          className="kt-width-full"
									                          name={field.fieldName}
									                          id={field.fieldName}
									                          //onBlur={handleBlur}
									                          onChange={this.handleChange}
									                          //value={values.firstName}
									                          //helperText={touched.firstName && errors.firstName}
									                          //error={Boolean(touched.firstName && errors.firstName)}
									                        />
								                        }

								                        {field.dataType === "wysiwyg" &&
					        												<>
						        										 <Editor
																		        editorState={this.state.editorState}
																		        wrapperClassName="demo-wrapper"
																		        editorClassName="demo-editor"
																		        onEditorStateChange={this.onEditorStateChange}
																		        toolbar={{
																		        	options: ['inline', 'blockType', 'fontSize', 'fontFamily', 'list', 'textAlign', 'colorPicker', 'link',  'remove', 'history']
																		        }}
																		        
																		      />
																					
																	        </>
								                        }

								                        {field.dataType === "textarea" &&
					        							
					        												<TextField
								                          margin="normal"
								                          label={field.displayName}
								                          className="kt-width-full"
								                          name={field.fieldName}
								                          id={field.fieldName}
								                          //onBlur={handleBlur}
								                          onChange={this.handleChange}
								                          multiline="true"
								                          rows="10"
								                          rowsMax="10"
								                          //value={values.firstName}
								                          //helperText={touched.firstName && errors.firstName}
								                          //error={Boolean(touched.firstName && errors.firstName)}
								                        />
								                        }
								                         {field.dataType === "checkboxgroup" &&
					        							
					        								<FormControl component="fieldset">
														        <FormLabel component="legend">{field.displayName}</FormLabel>
														        <FormGroup>
														          {field.values.map((val)=>(
														          	<>
														          <FormControlLabel
														            control={<Checkbox  onChange={this.handleCheckBoxChange} value={val} name={field.fieldName} />}
														            label={val}
														          />
														          </>
														          
														         ))}
														        </FormGroup>
														        
													      </FormControl>
								                        }
								                        {field.dataType === "checkboxgroupimage" &&
					        							
					        								<FormControl component="fieldset">
														        <FormLabel component="legend">{field.displayName}</FormLabel>
														        <div class="container" style={{'background-color':'#0B6CAF'}}>
														        {field.imagePosition === 'top' &&
														        <div className="row" style={{'border': '1px solid grey','background-color':field.background!==null && field.background=='white'? 'white':'#0B6CAF'}}>
														        <FormGroup row>
														          {field.imagePath.map((val)=>(
														          	<div className="col" style={{'border': '1px solid grey','width':'200px'}}>
														          	 <FormControlLabel 
															            control={<Figure.Image
										                	                alt="171x180"
															                src={val}
													              		/>}
													              	style={{'margin-left': 'auto','margin-right':'auto'}} />
													              		</div>
													              	
												  	          
														         ))}
														        </FormGroup>
														        </div>
														    	}
														        <div className="row" style={{'border': '1px solid grey'}}>
														        <FormGroup row >
														          {field.values.map((val)=>(
														          	<div className="col" style={{'border': '1px solid grey','width':'200px'}}>
													  		          <FormControlLabel 
															            control={<Checkbox style={{'margin-left':'0px','color':'white'}} onChange={this.handleCheckBoxChange} value={val} name={field.fieldName} fontSize="small" />}
															            label={val} labelPlacement="bottom"  style={{'margin-left':'0px','color':'white'}}

															          />
															          </div>
														         ))}
														        </FormGroup>
														        </div>
														        {field.imagePosition === 'bottom' &&
														        <div className="row" style={{'border': '1px solid grey','background-color':field.background!==null && field.background=='white'? 'white':'#0B6CAF'}}>
														        <FormGroup row>
														          {field.imagePath.map((val)=>(
														          	<div className="col" style={{'border': '1px solid grey','alignContent':'center', 'text-align': 'center','width':'200px'}}>
														          	 <FormControlLabel 
															            control={<Figure.Image
										                	                alt="171x180"
															                src={val}
													              		/>}
													              	style={{'margin-left': 'auto','margin-right':'auto'}} />
													              		</div>
													              	
												  	          
														         ))}
														        </FormGroup>
														        </div>
														    	}

																{field.bottomImage!= null &&
														        <div className="row" style={{'border': '1px solid grey'}}>
														      
														          	<Figure.Image
										                	                alt="171x180"
															                src={field.bottomImage}
													              		/>
													            
														        </div>
														    	}
																

														        </div>
														        
													      </FormControl>
								                        }
								                        {field.dataType === "checkbox" &&
					        								
					        								 <FormControlLabel control={<Checkbox name={field.fieldName} onChange={this.handleChange} value={field.displayName} />} label={field.displayName} />
					        																		            	
								                        }
								                        {field.dataType === "image" &&
								                        	
								                        	<Figure>
												              <Figure.Image
												                
												                alt="171x180"
												                src={field.displayName}
															/>
												            </Figure>
												           

								                        }
								                        </>
					        						))}
					        					</div>


					        				</div>
					        		
					        	</div>
				        	</div>
			        	</div>
		        	</div>
	        	))}

	        	<div className="row">
	        		<div className="col-lg-12">


                        <button
                          type="submit"
                            className={`btn btn-primary btn-elevate kt-login__btn-primary ${clsx(
                              {
                                "kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light": this.state.loading
                              }
                            )}`}
                          >
                           Update
                        </button> &nbsp; &nbsp;
                   		{/*<Link to={{pathname:this.state.fromPath, data:this.state.patient}}>Back</Link>*/}
	        		</div>
	        	</div>
				{this.state.status && this.state.fromPath === "/createpatient" && (
				<div className="row">
	        		<div className="col-lg-12">
					
                        <div role="alert" className={"alert "+this.state.statusColor}>
                          <div className="alert-text">{this.state.statusMessage + ". Kindly click close button"}</div>
                        </div>
                     
					</div>
				</div>
				 )}
	        	</form>
    		</>
    	);
	}	
}   

export default injectIntl(withStyles(styles)(AddTemplateData));